// extracted by mini-css-extract-plugin
module.exports = {"Container":"Container--2o2XT","Label":"Label--2JBlr","Value":"Value--1778l","Secondary":"Secondary--3KWaM"};